<script>
    import Cinema from "../components/Cinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        index,
        featureIndex,
        removeSkeleton,
        errorCallback,
        performance,
        cinemaInjectionContainerWidth,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let contentDresonRule = $state(),
        headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state(),
        hasPersonalisedRecommendations = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const res = await ajaxFetch(`/reco-core/recommendations/storefront`);
        removeSkeleton();
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            dreson: contentDresonRule,
            headline,
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            featuresState,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_storefront_cinema_wrapper">
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {performance}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            site="reco_Storefront"
            {contentDresonRule}
            personalisedUser={hasPersonalisedRecommendations}
        />
    </div>
{/if}

<style lang="scss">
    .reco_storefront_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;
    }
</style>
